import type {AddComponentTypeOptions, ComponentDefinition} from 'grapesjs';
import {asteriskHtml, createBaseBoxComponent} from '@FormMakerReact/components/create-base-box-component';
import {POSTERMYWALL_FORM_SPACER_TYPE} from '@FormMakerReact/components/postermywall-form-spacer/postermywall-form-spacer';
import {POSTERMYWALL_FORM_TEXT_TYPE} from '@FormMakerReact/components/postermywall-form-text/postermywall-form-text';
import {POSTERMYWALL_STREET_INPUT_TYPE} from '@FormMakerReact/components/postermywall-street-input/postermywall-street-input';
import {POSTERMYWALL_CITY_INPUT_TYPE} from '@FormMakerReact/components/postermywall-city-input/postermywall-city-input';
import {POSTERMYWALL_STATE_INPUT_TYPE} from '@FormMakerReact/components/postermywall-state-input/postermywall-state-input';
import {POSTERMYWALL_COUNTRY_INPUT_TYPE} from '@FormMakerReact/components/postermywall-country-input/postermywall-country-input';

export const POSTERMYWALL_ADDRESS_BOX_TYPE = 'postermywall-address-box';

const streetField: ComponentDefinition = {
  classes: 'street',
  tagName: 'div',
  components: [{type: POSTERMYWALL_STREET_INPUT_TYPE}],
};

const cityField: ComponentDefinition = {
  classes: 'city',
  tagName: 'div',
  style: {'margin-right': '16px', width: '100%'},
  components: [{type: POSTERMYWALL_CITY_INPUT_TYPE}],
};

const stateField: ComponentDefinition = {
  classes: 'state',
  tagName: 'div',
  style: {width: '100%'},
  components: [{type: POSTERMYWALL_STATE_INPUT_TYPE}],
};

const countryField: ComponentDefinition = {
  classes: 'country',
  tagName: 'div',
  style: {width: '100%'},
  components: [{type: POSTERMYWALL_COUNTRY_INPUT_TYPE}],
};

export const POSTERMYWALL_ADDRESS_BOX: AddComponentTypeOptions = createBaseBoxComponent({
  boxType: POSTERMYWALL_ADDRESS_BOX_TYPE,
  dataMarkerAttribute: 'data-is-pmw-form-address-box',
  components: [
    {type: POSTERMYWALL_FORM_SPACER_TYPE},
    {type: POSTERMYWALL_FORM_TEXT_TYPE, content: `<strong>Address${asteriskHtml()}</strong>`},
    {
      tagName: 'div',
      classes: 'pmw-address-box-separation-container',
      components: [
        streetField,
        {
          tagName: 'div',
          style: {display: 'flex', margin: '24px 0'},
          components: [cityField, stateField],
        },
        countryField,
      ],
    },
  ],
});
